import { useTranslation } from "react-i18next"
import HasPermission, { CanViewCompanyLog } from "app/PermissionChecker"
import { useGetUserActivityStatsQuery } from "features/core/log/api/logApiSlice"
import ActivityStats from "features/core/company/components/ActivityStats"
import React, { useEffect, useState } from "react"

function EmployeeActivityStats({ userGuid }) {
    const [t, i18n] = useTranslation("global")
    const canViewCompanyLog = HasPermission(CanViewCompanyLog)
    const [selectedDays, setSelectedDays] = useState(14);

    const {
        data,
        isFetching,
        isSuccess,
        isLoading,
        isError,
        error,
        refetch
    } = useGetUserActivityStatsQuery({ userGUID: userGuid, lastDaysNumber: selectedDays });


    // Refetch automatico su cambio filtro
    useEffect(() => {
        refetch({ userGUID: userGuid, lastDaysNumber: selectedDays });
    }, [selectedDays]);


    let content

    if (isSuccess) {
        content = <ActivityStats data={data} isLoading={isFetching} onChangeDaysNumber={setSelectedDays} />
    }
    return content
}

export default EmployeeActivityStats